import { useContext } from 'react';

import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import { AuthContext } from '@/contexts/auth/AuthContext';
import { BfwUserContextService, HeaderContent } from 'generatedBfw/static';

export const HeaderContentQueryKey = ['headerContentInfo'];

export function useHeaderContentInfo(): QueryObserverResult<HeaderContent> {
  const { fetchedUserInfo } = useContext(AuthContext);
  return useQuery<HeaderContent, Error>(
    HeaderContentQueryKey,
    () => BfwUserContextService.getHeaderContent(),
    {
      enabled: fetchedUserInfo,
      staleTime: Infinity,
    },
  );
}
